import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';

export default function Stats({
  stats,
  statsSettings,
}: componentTypes.StatsProps) {
  const { nbHits } = stats;

  const { translations } = statsSettings;

  return (
    <>
      <span className="font-semibold">{nbHits}</span>
      <p>{nbHits === 1 ? translations?.resultFound : translations?.resultsFound}</p>
    </>
  );
}
